export const mandantenStyles = {
    fieldsContentMandant: {
        box: {
            gridTemplateColumns: ['1fr', '1fr 1fr'],
            gap: 2,
            inlineBox: {
                width: '100%',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 2,
                alignItems: 'start',
            }
        },
        descriptionField: {
            gridColumn: 'span 2',
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        }
    },
    pageCreateMandant: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        }
    },
    pageUpdateMandant: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    },
    filterTableMandanten: {
        box: {
            backgroundColor: 'white'
        }
    },
    tableMandanten: {
        box: {
            minHeight: 600,
            height: "100%",
            overflow: 'auto',
            width: "100%"
        },
        paper: {
            padding: 2,
            paddingBottom: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    }
}